import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

/**
 * ForceRerenderProvider component
 * author: soojin.oh
 *
 * 강제로 화면 랜더링을 다시 해야할 경우에 사용한다.
 * 대부분의 경우는 사용할 일이 없을것으로 생각되나 아래와 같은 문제가 있어서 추가함
 *
 * ie 한정 모달에서 iframe 을 사용한 경우, history.back 을 호출하여도 rendering 이 다시 일어나지 않아 화면이 갱신되지
 * 않는 문제가 있다. (모달이 닫히지 않음)
 */

const RerenderContext = createContext({
  trigger: false,
  rerender: () => {},
})

// ForceRerenderProvider component
const ForceRerenderProvider = function ({ children }: PropsWithChildren) {
  const [trigger, setTrigger] = useState(false)
  const rerender = useCallback(() => {
    setTrigger(!trigger)
  }, [trigger])

  return (
    <RerenderContext.Provider value={{ trigger, rerender }}>{children}</RerenderContext.Provider>
  )
}

export default ForceRerenderProvider
export const useRerender = () => {
  const { trigger, rerender } = useContext(RerenderContext)
  useEffect(() => {}, [trigger])
  return { trigger, rerender }
}
